module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Ice-cream#1-7a5f5902b6fccdaa44584d08ac4afff5.svg";